import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { LocalizationContext, normalizeLocale } from '@local/services/localization';
import Button from '@Components/Button';
import EmbarkLogo from 'assets/icons/embark.svg';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LanguageSelect from '@Components/LanguageSelect';
import HeaderLinks from './components/HeaderLinks';
import './styles/header.scss';

export default function Header({
  loadLocale,
  openNavigationMenu,
  closeNavigationMenu,
  isNavigationMenuOpen,
  isNavigationVisible,
  isLanguageSelectVisible,
  locale,
  settings
}) {
  const localized = useContext(LocalizationContext);
  const normalizedLocale = normalizeLocale(locale);

  const logoLink = () => {
    return '/';
  };

  function toggleLocale(selectedLocale) {
    sessionStorage.setItem('locale', selectedLocale);
    loadLocale(selectedLocale);
  }

  // Handles the render of the right column of the navbar
  const renderColumnRight = () => {
    return (
      <React.Fragment>
        {isLanguageSelectVisible && (
          <LanguageSelect
            locale={locale}
            onLocaleSelect={selectedLocale => toggleLocale(selectedLocale)}
          />
        )}
        {isNavigationVisible && (
          isNavigationMenuOpen ? (
            <Button
              aria-label={localized['navigation.menu']}
              variant="text"
              size="small"
              className="header__menu-button"
              onClick={closeNavigationMenu}
            >
              <CloseIcon fontSize="small" />
            </Button>
          ) : (
            <Button
              variant="text"
              size="small"
              className="header__menu-button"
              onClick={isNavigationMenuOpen ? closeNavigationMenu : openNavigationMenu}
            >
              <MenuIcon fontSize="small" />
            </Button>
          )
        )}
      </React.Fragment>
    );
  };

  return (
    <AppBar className="header">
      <Toolbar className="header__toolbar">
        <div className="header__column-left">
          <Link to={logoLink()}>
            <div className="header__logo__container">
              <img
                className="header__logo"
                src={EmbarkLogo}
                alt={localized['home.logoLinkUnAuthenticatedAlt']} />
            </div>
          </Link>
          <HeaderLinks locale={normalizedLocale} settings={settings} localized={localized} />
        </div>
        <div className="header__column-right">
          {renderColumnRight()}
        </div>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  loadLocale: PropTypes.func,
  openNavigationMenu: PropTypes.func,
  closeNavigationMenu: PropTypes.func,
  isNavigationMenuOpen: PropTypes.bool,
  isNavigationVisible: PropTypes.bool,
  isLanguageSelectVisible: PropTypes.bool,
  locale: PropTypes.string,
  settings: PropTypes.object
};
